import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
	import aps from '@/HostApp/store/ApsModules/ApsModule';

	
	const __default__ = {
		name: 'BacktopUIAddon',
		inheritAttrs: false
	};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const target = computed(() => {
		if (!aps.navigation.isVueWorkspace) {
			return '#ccp-wrapper';
		} else {
			return '';
		}
	});

return { __sfc: true,target }
}

})